import React from 'react';

export default class BellSlashIcon extends React.Component {
    constructor(props) {
        super(props);
        this.loadSvg();
        this.setIconElement();
    }

    loadSvg() {
        this.iconSvg = '<!--! Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96l8 0 8 0c57.4 0 104 46.6 104 104l0 33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48-176.9 0c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1l0 11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l286.2 0zM384 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"/>';
    }

    setIconElement() {
        const styles = this.props?.style || {};
        const width = this.props?.width || 14;
        const height = this.props?.height || 16;
        if (!styles?.width) {
            styles.width = `${width}px`;
        }
        if (!styles?.height) {
            styles.height = `${height}px`;
        }
        this.iconElement = (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width={width} height={height} style={styles} dangerouslySetInnerHTML={{ __html: this.iconSvg }}></svg>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props?.style === prevProps?.style && this.props?.width === prevProps?.width && this.props?.height === prevProps?.height) {
            return;
        }
        this.setIconElement();
    }

    render() {
        return this.iconElement;
    }
}
